// src/data/companies.js
export const companies = [
  {
    key: "WYNN",
    name: "Wynn Tax Solutions",
    slug: "wynn-tax-solutions",
    tagline: "Individuals & All Businesses",
    specialties: ["complex_corporate", "business", "payroll_941"],
    phone: "866-939-6991",
    callrailNumber: "(800) 000-0001",
    siteUrl: (() => {
      const base = "https://www.wynntaxsolutions.com/";
      const params = new URLSearchParams(window.location.search);

      // Always include the CAR referral source
      params.set("utm_source", "consumeradvocatereviews");
      params.set("utm_medium", "referral");
      params.set("utm_campaign", "listing");

      // Preserve existing ad tracking (if any)
      // These will automatically carry over if present in the current URL
      const preserved = [
        "gclid",
        "utm_term",
        "utm_content",
        "utm_campaignid",
        "network",
        "device",
        "matchtype",
      ];
      preserved.forEach((key) => {
        const val = new URLSearchParams(window.location.search).get(key);
        if (val && !params.has(key)) params.set(key, val);
      });

      return `${base}?${params.toString()}`;
    })(),
    ratingAggregate: 4.6,
    reviewCount: 55,
    logo: "/images/wynn-logo.png",

    inquiryEmail: "",
    reviewSnippet:
      "Excellent with payroll tax issues—precise strategy, steady updates, and strong results.",
    services: [
      {
        code: "payroll-941",
        name: "Payroll/941 Resolution",
        short: "Late deposits, penalties, and plan setup.",
        details:
          "Trust fund recovery defense, penalty abatements, and time-sensitive compliance work.",
        startingAt: 2200,
      },
      {
        code: "audit-defense",
        name: "IRS & State Audit Defense",
        short: "Representation through exam and appeals.",
        details:
          "Information requests, substantiation, interviews, and strategy across multiple years.",
        startingAt: 2500,
      },
      {
        code: "business-back-returns",
        name: "Business Back Returns",
        short: "Corporate, partnership, and multi-state filings.",
        details:
          "Revenue reconstruction, reasonable-cause narratives, and state coordination.",
        startingAt: 900,
      },
    ],
    coverage: "Nationwide",
    locations: ["Irvine, CA (HQ)", "Remote team"],
    featured: true,
    badgeText: "Editor’s Pick",
    accentColor: "purple.600",
    pricing: { model: "flat", range: [2000, 8000], freeConsult: true },
    languages: ["English"],
    links: {
      schedule:
        "https://calendar.google.com/calendar/u/0/appointments/schedules/AcZssZ25FNV71VMVLAUJcTF7ew9IqXjDdCzrCVM3iO807VWuVJI6rN411BUs7LWWa44uiGOkg9ELYCmy?gv=true",
      reviews: { google: "https://google.com/maps?cid=wynn" },
    },
    intake: {
      formUrl: "https://wynntaxsolutions.com/qualify-now",
      averageStartTime: "24h",
    },
  },
  {
    key: "TAG",
    name: "Tax Advocate Group",
    slug: "tax-advocate-group",
    tagline: "Individuals & Small Businesses",
    specialties: ["individual_1040", "small_business"],
    phone: "866-304-4751",
    callrailNumber: "(800) 000-0000",
    siteUrl: (() => {
      const base = "https://www.taxadvocategroup.com/";
      const params = new URLSearchParams(window.location.search);

      // Always include the CAR referral source
      params.set("utm_source", "consumeradvocatereviews");
      params.set("utm_medium", "referral");
      params.set("utm_campaign", "listing");

      // Preserve existing ad tracking (if any)
      // These will automatically carry over if present in the current URL
      const preserved = [
        "gclid",
        "utm_term",
        "utm_content",
        "utm_campaignid",
        "network",
        "device",
        "matchtype",
      ];
      preserved.forEach((key) => {
        const val = new URLSearchParams(window.location.search).get(key);
        if (val && !params.has(key)) params.set(key, val);
      });

      return `${base}?${params.toString()}`;
    })(),
    ratingAggregate: 4.3,
    reviewCount: 93,
    logo: "/images/tag-logo.png",

    // NEW fields
    inquiryEmail: "",
    reviewSnippet:
      "Clear plan on day one and fast communication. Helped stop a pending levy within 48 hours.",
    services: [
      {
        code: "offer-in-compromise",
        name: "Offer in Compromise",
        short: "Settle for less than owed when eligible.",
        details:
          "Household standard analysis, RCP modeling, package assembly, and IRS submissions.",
        startingAt: 1500,
      },
      {
        code: "installment-agreement",
        name: "Installment Agreements",
        short: "Affordable monthly plans with the IRS.",
        details:
          "Streamlined, regular, or partial-pay plans structured to your cash flow.",
        startingAt: 750,
      },
      {
        code: "cnc",
        name: "Currently Not Collectible",
        short: "Pause collections during financial hardship.",
        details:
          "Hardship proof using national/local standards and supporting documentation.",
        startingAt: 900,
      },
      {
        code: "back-returns",
        name: "Back Tax Returns",
        short: "Reconstruct income and file missing years.",
        details:
          "Transcript pull, wage/income reconstruction, deduction review, and state alignment.",
        startingAt: 400,
      },
    ],
    coverage: "Nationwide",
    locations: ["Chatsworth, CA (HQ)"],
    featured: true,
    badgeText: "Featured",
    accentColor: "blue.600",
    pricing: {
      model: "hybrid",
      range: [1200, 4500],
      freeConsult: true,
      guarantee:
        "Refund if not satisfied with services rendered based on verified work product.",
    },
    languages: ["English", "Spanish"],
    links: {
      schedule:
        "https://calendar.google.com/calendar/u/0/appointments/schedules/AcZssZ0Kxq5XizQAYPmTlpO421RhAhiUYBNC-0ZChcIvzbsI0rEAQ94_M7f9cf0yJpS8SkoqNlHwEryD?gv=true",

      reviews: {
        google: "https://google.com/maps?cid=tag",
      },
    },
    intake: {
      formUrl: "https://taxadvocategroup.com/contact-us",
      averageStartTime: "24–48h",
    },
  },

  {
    key: "ATS",
    name: "American Tax Support",
    slug: "american-tax-support",
    tagline: "Truckers & 1099 Workers",
    specialties: ["truckers_1099", "individual_1040"],
    phone: "866-739-7618",

    siteUrl: "https://ameritaxsupport.com/",
    ratingAggregate: 4.2,
    reviewCount: 82,
    logo: "/images/ats-logo.png",

    inquiryEmail: "",
    reviewSnippet:
      "Understands 1099 realities—set up quarterlies and got a manageable plan fast.",
    services: [
      {
        code: "quarterlies",
        name: "Estimated Quarterlies",
        short: "Projection setup and penalty-smart cadence.",
        details:
          "Safe-harbor targeting, reminders, and payments tuned to seasonal cash flow.",
        startingAt: 250,
      },
      {
        code: "payment-plans",
        name: "Payment Plans",
        short: "Streamlined repayment based on cash flow.",
        details:
          "Simplified documentation and portal guidance suited to solo operators.",
        startingAt: 600,
      },
      {
        code: "unfiled-returns",
        name: "Unfiled Returns",
        short: "Transcript-driven W2/1099 pulls and filings.",
        details:
          "Deduction review, state coordination, and compliance plan for the next year.",
        startingAt: 350,
      },
    ],
    coverage: "Nationwide",
    locations: ["Phoenix, AZ (HQ)"],
    featured: false,
    badgeText: null,
    accentColor: "green.600",
    pricing: { model: "flat", range: [500, 2500], freeConsult: true },
    languages: ["English", "Spanish"],
    links: {
      schedule: "https://cal.example.com/ats",
      reviews: { google: "https://google.com/maps?cid=ats" },
    },
    intake: { formUrl: "https://ameritaxsupport.com/contact-us" },
  },

  {
    key: "AMITY",
    name: "Amity Tax Group",
    slug: "amity-tax-group",
    tagline: "Individuals & Businesses",
    specialties: ["individual_1040", "small_business", "business"],
    phone: "866-379-6253",

    siteUrl: "https://amitytaxgroup.com",
    ratingAggregate: 4.0,
    reviewCount: 63,
    logo: "/images/amity-logo.png",

    inquiryEmail: "",
    reviewSnippet:
      "Great at managing state & IRS together; proactive checklist kept things moving.",
    services: [
      {
        code: "lien-withdrawal",
        name: "Lien Withdrawal",
        short: "Remove or release a tax lien when eligible.",
        details:
          "Withdrawal, release, or subordination based on program rules and mortgage needs.",
        startingAt: 800,
      },
      {
        code: "state-alignment",
        name: "State Coordination",
        short: "Bring state filings and balances current with IRS.",
        details:
          "Priority sequencing, penalty relief where possible, and single point of contact.",
        startingAt: 700,
      },
      {
        code: "settlement",
        name: "Settlement Options",
        short: "OIC/CNC and hybrid strategies.",
        details:
          "Standards modeling, equity review, and documentation coaching.",
        startingAt: 1400,
      },
    ],
    coverage: "Nationwide",
    locations: ["Denver, CO (HQ)"],
    featured: false,
    badgeText: null,
    accentColor: "teal.600",
    pricing: { model: "hybrid", range: [1000, 4200], freeConsult: true },
    languages: ["English"],
    links: {
      schedule:
        "https://calendar.google.com/calendar/u/0/appointments/schedules/AcZssZ0g5Bkw-JFnEamVr_peUKs3gJ6ob7nKVyuHUxcXK3t6yZkIxyMYIqq6DHeEoBo25pZ9MW8b8WNb?gv=true",
    },
    intake: {
      formUrl: "https://amitytaxgroup.com/contact-us",
      averageStartTime: "48–72h",
    },
  },

  {
    key: "TGC",
    name: "Tax Group Consultants",
    slug: "tax-group-consultants",
    tagline: "Business & Complex Returns",
    specialties: ["business", "complex_corporate", "payroll_941"],
    phone: "866-964-3565",
    callrailNumber: "(800) 000-0004",
    siteUrl: "https://taxgroupconsultants.com",
    ratingAggregate: 4.3,
    reviewCount: 93,
    logo: "/images/tgc-logo.png",

    inquiryEmail: "",
    reviewSnippet:
      "Responsive team; moved fast to lift a levy and set a practical path forward.",
    services: [
      {
        code: "levy-release",
        name: "Levy Release",
        short: "Emergency action to lift levies when possible.",
        details:
          "Rapid financial snapshot, hardship proof, and same-day escalations when timelines are tight.",
        startingAt: 1200,
      },
      {
        code: "trust-fund",
        name: "Trust Fund Defense (TFRP)",
        short: "Mitigate exposure and structure repayment.",
        details:
          "Interviews, responsibility mapping, appeals strategy, and payment options.",
        startingAt: 2600,
      },
      {
        code: "appeals",
        name: "Appeals",
        short: "Challenge penalties and determinations.",
        details:
          "Reasonable cause standards, documentation sets, conference representation.",
        startingAt: 1800,
      },
    ],
    coverage: "Nationwide",
    locations: ["Los Angeles, CA (HQ)"],
    featured: false,
    badgeText: null,
    accentColor: "orange.600",
    pricing: { model: "flat", range: [1500, 6000], freeConsult: true },
    languages: ["English"],
    links: {
      schedule:
        "https://calendar.google.com/calendar/u/0/appointments/schedules/AcZssZ0Kxq5XizQAYPmTlpO421RhAhiUYBNC-0ZChcIvzbsI0rEAQ94_M7f9cf0yJpS8SkoqNlHwEryD?gv=true",
    },
    intake: { formUrl: "https://taxgroupconsultants.com/contact-us" },
  },
];
